import type { MultiPolicyV2 } from "@b2bportal/air-shopping-api";
import {
  type BundledPackageState,
  type ChosenFlight,
  type ChosenProductsResponse,
  PackageType,
} from "@b2bportal/core-packages";
import type { RestrictionCancel } from "@b2bportal/ground-api";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface PackageBaseState {
  currentActivePackage?: BundledPackageState;
  currentActivePackageType?: PackageType;
  benchmarkProducts?: ChosenProductsResponse;
  selectedFlightCancellationPolicy?: MultiPolicyV2;
  selectedCarCancellationPolicy?: RestrictionCancel;
  pendingChosenFlight?: ChosenFlight;
}

export const initialBaseState: PackageBaseState = {
  currentActivePackage: undefined,
  currentActivePackageType: PackageType.HOTEL_FLIGHT_CAR,
  selectedFlightCancellationPolicy: undefined,
  selectedCarCancellationPolicy: undefined,
};

export const packagesBaseSlice = createSlice({
  name: "packages/base",
  initialState: initialBaseState,
  reducers: {
    setCurrentActivePackage: (
      state,
      action: PayloadAction<BundledPackageState>
    ) => {
      state.currentActivePackage = action.payload;
    },
    setCurrentActivePackageToken: (state, action: PayloadAction<string>) => {
      state.currentActivePackage = {
        ...state.currentActivePackage,
        token: { value: action.payload },
      };
    },
    setCurrentActivePackageType: (
      state,
      action: PayloadAction<PackageType>
    ) => {
      state.currentActivePackageType = action.payload;
    },
    setBenchmarkProducts: (
      state,
      action: PayloadAction<ChosenProductsResponse>
    ) => {
      state.benchmarkProducts = action.payload;
    },
    clearBenchmarkProducts: (state) => {
      state.benchmarkProducts = undefined;
      state.selectedFlightCancellationPolicy = undefined;
      state.selectedCarCancellationPolicy = undefined;
    },
    setSelectedFlightCancellationPolicy: (
      state,
      action: PayloadAction<MultiPolicyV2 | undefined>
    ) => {
      state.selectedFlightCancellationPolicy = action.payload;
    },
    setSelectedCarCancellationPolicy: (
      state,
      action: PayloadAction<RestrictionCancel | undefined>
    ) => {
      state.selectedCarCancellationPolicy = action.payload;
    },
    setPendingChosenFlight: (state, action: PayloadAction<ChosenFlight>) => {
      state.pendingChosenFlight = action.payload;
    },
    clearPendingChosenFlight: (state) => {
      state.pendingChosenFlight = undefined;
    },
  },
});

export const PackagesBaseActions = packagesBaseSlice.actions;
export default packagesBaseSlice.reducer;
